export const ALIGNS = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};
